<div class="loading-container">
  <itl-loading-indicator></itl-loading-indicator>
  <h2 class="loading-text">{{ 'chat.channels.loading' | translate }}</h2>
</div>
